/**
 * @desc 员工信息导入
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(body: string, options?: any) {
  return updateResponse(
    http(URL + `/organizationStaff/import/staffInfo`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
